import React from 'react';
import { Star, Quote } from 'lucide-react';

export function CommercialTestimonial() {
  return (
    <section className="py-20 sm:py-28 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <div className="animate-on-scroll text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Trusted by Commercial Property Professionals
          </h2>
        </div>

        <div className="animate-on-scroll relative bg-gradient-to-br from-gray-50 to-white rounded-3xl border border-gray-200 p-8 sm:p-12 shadow-elevated">
          <Quote className="absolute top-6 left-6 sm:top-8 sm:left-8 w-10 h-10 text-gray-200" />

          <div className="relative z-10 text-center">
            <p className="text-sm text-emerald-600 font-semibold mb-4">Saved &pound;8,000+ in solicitor fees</p>

            <div className="flex items-center justify-center gap-1 mb-6">
              {[1, 2, 3, 4, 5].map((n) => (
                <Star key={n} className="w-5 h-5 text-amber-400 fill-amber-400" />
              ))}
            </div>

            <p className="text-xl sm:text-2xl text-gray-800 leading-relaxed font-medium italic mb-8 max-w-2xl mx-auto">
              "We manage 12 commercial properties and were paying solicitors &pound;2,000+ per lease review. RentFix identified
              a critical LTA 1954 contracting-out failure in our first review that our solicitor had missed. The clause-by-clause
              comparison gave us complete confidence in the rewritten lease. We now use it for every new lease and renewal."
            </p>

            <div className="flex flex-col items-center gap-3">
              <div className="w-14 h-14 bg-emerald-600 rounded-full flex items-center justify-center">
                <span className="text-white text-lg font-bold">MT</span>
              </div>
              <div>
                <p className="font-semibold text-gray-900">Michael Thompson</p>
                <p className="text-sm text-gray-500">Commercial Property Manager</p>
              </div>
            </div>

            <p className="text-sm text-gray-400 italic mt-6">
              "The negotiation recommendations alone saved us thousands"
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
